import React from "react";
import { StyledSvg } from "baseui/icon";

export const PencilIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg viewBox="0 0 17 17" fill="none" {...props}>
    <path
      d="M12.9579 2.24478C12.3597 2.24478 11.7615 2.47157 11.3082 2.92512L3.92991 10.3027C3.78992 10.4427 3.68739 10.6168 3.63303 10.8079L2.6441 14.2708C2.61971 14.3565 2.61866 14.4472 2.64105 14.5334C2.66344 14.6196 2.70846 14.6983 2.77146 14.7613C2.83446 14.8243 2.91314 14.8693 2.99937 14.8917C3.0856 14.9141 3.17625 14.9131 3.26194 14.8887L6.72548 13.8997L6.72613 13.8991C6.91597 13.8445 7.08964 13.7433 7.23004 13.6029L14.6076 6.2246C15.5147 5.31756 15.5147 3.83216 14.6076 2.92512C14.1543 2.47157 13.5561 2.24478 12.9579 2.24478ZM10.3323 5.31509L12.2177 7.20051L6.52236 12.8958C6.50281 12.9152 6.47806 12.9301 6.45009 12.9381L6.12066 13.0319L4.50022 11.4114L4.59462 11.082V11.0814C4.60227 11.0545 4.61627 11.0304 4.63694 11.0098L10.3323 5.31509Z"
      fill="black"
    />
  </StyledSvg>
);
